const StoreService = {
  store: {},
  setStore: (newStore) => {
    StoreService.store = newStore;
  },
  getStore: () => StoreService.store,
};

export default StoreService;
